module.exports = __webpack_public_path__ + "img/G.72d5cae7.webp";